import that from '../../translationHelper'

const userNameRules = [
	{
		pattern: /[^a-z0-9_.]/i,
		match: false,
		message: that.context.translate('can only contain letters, numbers, periods and underscores')
	},
	{
		pattern: /^\.|\.$/, // this rule also prevents 1 char username, not on purpose, not worth allowing
		match: false,
		message: that.context.translate('can not start or end with a period')
	},
	{
		pattern: /[a-z0-9]/i,
		match: true,
		message: that.context.translate('must have at least one letter or number')
	}
]

export default userNameRules



// WEBPACK FOOTER //
// ./src/utilities/Data/User/userNameRules.js